import React from 'react';
import "./MenuModal.css";

const titleCase = (value) =>
  String(value || "").toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

// Compact panel anchored above the Categories button, listing every cuisine so a
// guest can jump straight to one instead of scrolling.
export default function MenuModal({ setMenuModal, menu, onSelectType, activeType, raised }) {

  const handleClose = () => setMenuModal(false);

  const typeCounts = {};

  (menu || []).forEach((item) => {
    const type = item.type || 'Other';
    typeCounts[type] = (typeCounts[type] || 0) + 1;
  });

  const types = Object.keys(typeCounts).sort((a, b) => {
    if (a === 'Other') return 1;
    if (b === 'Other') return -1;
    return a.localeCompare(b);
  });

  const jumpTo = (type, e) => {
    e.preventDefault();
    onSelectType(type);
    setMenuModal(false);
  };

  return (
    <div className="menu-sheet-overlay" onClick={handleClose}>
      <div
        className={`menu-sheet ${raised ? 'raised' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >

        <div className="menu-sheet-head">
          <h3>Browse the menu</h3>
        </div>

        <div className="menu-sheet-body">
          <div className="menu-sheet-section">
            {types.map((type) => (
              <button
                className="menu-sheet-row"
                key={type}
                onClick={(e) => jumpTo(type, e)}
              >
                <span>
                  {titleCase(type)}
                  {type === activeType && <span className="menu-sheet-showing">Showing</span>}
                </span>
                <span className="menu-sheet-count">{typeCounts[type]}</span>
              </button>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}
